import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
  state: {
    taxLabels: [],
    categories: []
  },
  getters: {
    getTaxLabels: state => state.taxLabels,
    getAllMainCategories: (state) => {
      let finalArray = [];
      let categories = state.categories.map(category => $utils.toPascalCase(category.MainCatName));
      for (let i = 0; i < categories.length; i++) {
        let mainCategory = categories[i];
        if (!finalArray.includes(mainCategory)) {
          finalArray.push(mainCategory)
        }
      }
      return finalArray.sort((a, b) => a.localeCompare(b));
    },

    getAllSubCategories: (state) => (mainCategory) => {
      let finalArray = [];
      let categories = state.categories
        .filter(category => category.MainCatName.toLowerCase() === mainCategory.toLowerCase())
        .filter(category => {
          if (category.SubCatName) return category.SubCatName.trim() !== '';
        }).map(category => $utils.toPascalCase(category.SubCatName));
      for (let i = 0; i < categories.length; i++) {
        let subCategory = categories[i];
        if (!finalArray.includes(subCategory)) {
          finalArray.push(subCategory)
        }
      }
      return finalArray.sort((a, b) => a.localeCompare(b));
    },

    getAllSub2Categories: (state) => (mainCategory, subDep) => {
      let finalArray = [];
      if (!finalArray) return finalArray;
      let categories = state.categories
        .filter(category => category.MainCatName.toLowerCase() === mainCategory.toLowerCase())
        .filter(category => category.SubCatName && category.SubCatName.toLowerCase() === subDep.toLowerCase())
        .filter(category => category.SubCatName2.trim() !== '')
        .map(category => $utils.toPascalCase(category.SubCatName2));
      for (let i = 0; i < categories.length; i++) {
        let sub2Category = categories[i];
        if (!finalArray.includes(sub2Category)) {
          finalArray.push(sub2Category)
        }
      }
      return finalArray.sort((a, b) => a.localeCompare(b));
    },
  },
  mutations: {
    setTaxLabels(state, taxLabels) {
      state.taxLabels = taxLabels;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
  },
  actions: {
    /**
     * Fetch detailed list of items below minimum stock level for the selected timeframe.
     * Uses window.reportsApi as base and sends `group` header (base64) and timeframe params from getters.
     * @param {Object} context Vuex context
     * @returns {Promise<Array>} Array of detail rows: { storeName, plu, description, currentQty, minimumQty, idealLevel, qtyToIdeal }
     */
    // getItemsBelowMinDetails: async (context) => {
    //   let stores = JSON.parse(localStorage.getItem(`stores`));
    //   if (!stores || stores.length === 0) return [];
    //
    //   let group = stores[0].Group;
    //   let headers = { group: window.btoa(group) };
    //   let params = context.getters.getTimeFrame;
    //
    //   return axios
    //     .get(reportsApi + `stock-dashboard/overview/items-below-min/details`, { headers, params })
    //     .then(({ data }) => Array.isArray(data) ? data : [])
    //     .catch((err) => {
    //       errorHandler.tomcatError(err);
    //       return [];
    //     });
    // },

    /**
     * Fetch detailed list for Stock Take Variances across the franchise for the selected timeframe.
     * Uses window.reportsApi as base and sends `group` header (base64) and timeframe params from getters.
     * Do not call this API directly from components — enforce Vuex usage per guidelines.
     * @param {Object} context Vuex context
     * @returns {Promise<Array<object>>} Array of detail rows; returns empty array on error
     */
    getStockTakeVariancesDetails: async (context) => {
      let stores = JSON.parse(localStorage.getItem('stores'));
      if (!stores || stores.length === 0) return [];

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame; // { from, to }

      return axios
        .get(reportsApi + `stock-dashboard/overview/variances/details`, { headers, params })
        .then(({ data }) => (Array.isArray(data) ? data : []))
        .catch((err) => {
          errorHandler.tomcatError(err);
          return [];
        });
    },
    getStockData: async (context, data) => {
      let route = data.route;
      let query = data.query;

      let payload = {
        ...query,
        ...context.getters.getTimeFrame,
      };

      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => {
          return data;
        })
        .catch((err) => errorHandler.tomcatError(err));
    },
    getCookingMsg: async (_, plu) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;

      let storeDB = store.StoreDB;

      return axios
        .get(serverApi + `cookinginstruction/${storeDB}/${plu}`)
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
    getSearchStock: async (content, query) => {
      let payload = {
        ...query,
      };

      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;

      let storeDB = store.StoreDB;

      return axios
        .post(
          backOfficeTomcatApi + `stockUtils/${storeDB}/StockSearch`,
          payload
        )
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
    getStockHistory: async (context, plu) => {
      let payload = {
        ...context.getters.getTimeFrame,
        plu,
      };

      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;

      let storeDB = store.StoreDB;

      let headers = {
        DB: window.btoa(storeDB),
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `stock-history/time-frame-sales` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },

    //pprinting
    async printStockPDF(context, fileData) {
      let route = fileData.route;
      let fileName = fileData.fileName;
      let payload = {
        ...context.getters.getTimeFrame,
      };

      let stores = JSON.parse(localStorage.getItem("stores"));
      if (!stores || stores.length === 0) return;

      let group = stores[0].Group;
      let store = JSON.parse(localStorage.getItem("selected_store"));
      let storeDB = store && store.StoreDB;
      if (!storeDB) {
        Toast && Toast.fire && Toast.fire({
          icon: "error",
          title: "Store Selection Required",
          text: "Please select a store to continue.",
          timer: 3000,
        });
        return;
      }

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
        DB: window.btoa(storeDB),
      };

      try {
        const response = await axios.get(docsApi + `${route}` + queryString, {
          headers,
          responseType: `blob`,
        });
        openFile(response, fileName);
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },
    async printStockCSV(context, fileData) {
      let route = fileData.route;
      let fileName = fileData.fileName;
      let payload = {
        ...context.getters.getTimeFrame,
      };

      let stores = JSON.parse(localStorage.getItem("stores"));
      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let store = JSON.parse(localStorage.getItem("selected_store"));
      let storeDB = store && store.StoreDB;
      if (!storeDB) {
        Toast && Toast.fire && Toast.fire({
          icon: "error",
          title: "Store Selection Required",
          text: "Please select a store to continue.",
          timer: 3000,
        });
        return;
      }

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
        DB: window.btoa(storeDB),
      };

      try {
        const response = await axios.get(docsApi + `${route}` + queryString, {
          headers,
          responseType: `blob`,
        });
        openFile(response, fileName);
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    getFranchisePurchases : (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };
      return axios.get(reportsApi+`stock-dashboard/purchases`,{
        params : context.getters.getTimeFrame,
        headers
      }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },

    getFranchiseStockStats:async (context) => {
      try {
        const [departmentsRes, itemsBelowMinRes, variancesRes, totalValueRes] = await Promise.all([
          context.dispatch('getTotalDepartments'),
          context.dispatch('getItemsBelowMin'),
          context.dispatch('getStockTakeVariances'),
          context.dispatch('getTotalStockValue')
        ]);

        return {
          totalDepartments: departmentsRes.totalDepartments,
          itemBelowMinLevel: itemsBelowMinRes.itemsBelowMin,
          stocktakeDifferenceCount: variancesRes.variances,
          stockValue: totalValueRes.totalValue,
          departmentValues: await context.dispatch('getStockValueByDepartment').then(data => data)
        };
      } catch (err) {
        errorHandler.tomcatError(err);
        return {
          totalDepartments: 0,
          itemBelowMinLevel: 0,
          stocktakeDifferenceCount: 0,
          stockValue: 0,
          departmentValues: []
        };
      }
    },

    getTotalDepartments: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { totalDepartments: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/overview/departments`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { totalDepartments: 0 };
        });
    },

    getItemsBelowMin: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { itemsBelowMin: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/overview/items-below-min`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { itemsBelowMin: 0 };
        });
    },

    /**
     * Get detailed list of items that are below minimum across the franchise.
     * Headers: { group: base64(Franchise Group) }
     * Query: from, to (from getters.getTimeFrame)
     * @returns {Promise<Array<{storeName:string, plu:string, description:string, currentQty:number, minimumQty:number, idealLevel:number, qtyToIdeal:number}>>}
     */
    getItemsBelowMinDetails: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (!stores || stores.length === 0) return [];

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame; // { from, to }

      return axios
        .get(reportsApi + `stock-dashboard/overview/items-below-min/details`, { headers, params })
        .then(({ data }) => (Array.isArray(data) ? data : []))
        .catch((err) => {
          errorHandler.tomcatError(err);
          return [];
        });
    },

    getStockTakeVariances: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { variances: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/overview/variances`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { variances: 0 };
        });
    },

    getTotalStockValue: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { totalValue: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/overview/total-value`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { totalValue: 0 };
        });
    },

    /**
     * Fetch total stock value filtered by specific store(s).
     * Calls GET /api/v2/stock-dashboard/overview/total-value/by-store?from=...&to=...&store=...
     * @param {Object} context Vuex context
     * @param {Object} payload - { from, to, store } - timeframe dates and optional storeDB filter
     * @returns {Promise<{totalValue: number, from: string, to: string, storeName?: string, storeCount?: number}>}
     */
    getTotalStockValueByStore: async (context, { from, to, store }) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { totalValue: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = { from, to };

      if (store) {
        params.store = store;
      }

      return axios.get(window.reportsApi+`stock-dashboard/overview/total-value/by-store`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { totalValue: 0 };
        });
    },

    /**
     * Fetch historical (period-cost) stock value as of a specific date.
     *
     * Calls `GET /api/v2/stock/historical-value?asOfDate=...&store?...`. Period
     * cost = the cost actually paid at the last goods receipt on/before
     * `asOfDate`, summed across every non-archived PLU in every store that
     * belongs to the decoded `group` header (and, if `?store=` is provided,
     * scoped to that store). Differs from `/overview/current-value` (live
     * snapshot, includes some InclCost rows that period cost corrects).
     *
     * Scope rules (per FE dev note, 2026-09-15): use ONE scope signal per
     * call. Either `?store=` query param OR `db` header, never both. Both
     * omitted = group aggregate.
     *
     * Backward compatible:
     *  - Plain `yyyy-MM-dd` string payload (dashboard's legacy call) = uses
     *    `db` header from localStorage.
     *  - Config object without `store` key = same legacy behaviour.
     *  - Config object with `store: 'sparkrise_spark_rise'` = uses
     *    `?store=sparkrise_spark_rise`, omits `db` header.
     *  - Config object with `store: null` or `store: ''` = "All Stores":
     *    both signals omitted for true group aggregate.
     *
     * @param {Object} context Vuex context
     * @param {string|Object} payload - Plain `yyyy-MM-dd` string (legacy), OR
     *   `{ asOfDate: string, asOfDateTime?: string, signal?: AbortSignal,
     *      timeoutMs?: number, store?: string|null }` where:
     *      - `asOfDateTime` (e.g. "2026-09-15 00:00:00") overrides `asOfDate`
     *      - `timeoutMs` defaults to 90 s
     *      - `store` selects the scope signal (omit key entirely for legacy)
     * @returns {Promise<{totalValue: number, httpStatus: number, scope?: string,
     *   error?: string, aborted?: boolean, timedOut?: boolean}>}
     */
    getHistoricalStockValue: async (context, payload) => {
      const config = (typeof payload === 'string' || payload == null)
        ? { asOfDate: payload }
        : (payload || {});

      let stores;
      try {
        stores = JSON.parse(localStorage.getItem(`stores`));
      } catch (_) {
        stores = null;
      }
      if (!stores || stores.length === 0) {
        return { totalValue: 0, httpStatus: 409, error: 'No store selected.' };
      }

      const group = stores[0].Group;

      // Resolve scope signal: legacy (db header), explicit ?store=, or both
      // omitted (group aggregate). Only ONE signal ever ships — per the FE
      // dev note rule "don't keep separate db header state and store query
      // state. Read state -> write both header and query string from one
      // source."
      let dbHeader;
      let queryStore;
      let scope;
      if (Object.prototype.hasOwnProperty.call(config, 'store')) {
        if (typeof config.store === 'string' && config.store.length > 0) {
          queryStore = config.store;
          scope = '?store=' + config.store;
        } else {
          // Caller explicitly cleared the scope (null/'') = All Stores.
          scope = 'group aggregate (no signals)';
        }
      } else {
        // Legacy path (dashboard's plain-string call): DB header from the
        // active store in localStorage.
        const legacyDb = stores[0].StoreDB;
        if (legacyDb) dbHeader = window.btoa(String(legacyDb));
        scope = 'db header (legacy)';
      }

      const headers = {
        group: window.btoa(String(group)),
        ...(dbHeader ? { db: dbHeader } : {}),
      };
      const params = { asOfDate: config.asOfDateTime || config.asOfDate };
      if (queryStore) params.store = queryStore;

      // Client-side safety net. Explicit-time queries can take 1-2 minutes on
      // large groups per the FE dev note; 90 s is generous but bounded so the
      // UI doesn't pin forever. The dashboard's bare-date path completes in
      // ~1 s and never hits this.
      const timeoutMs = (typeof config.timeoutMs === 'number' && config.timeoutMs > 0)
        ? config.timeoutMs
        : 90000;
      const timeoutController = new AbortController();
      let timedOut = false;
      const timeoutId = setTimeout(() => {
        timedOut = true;
        timeoutController.abort();
      }, timeoutMs);

      // Chain the caller's signal through the same controller so a navigate-
      // away or new-request abort fires the timeout too.
      let externalAbortHandler;
      if (config.signal) {
        if (config.signal.aborted) {
          timeoutController.abort();
        } else {
          externalAbortHandler = () => timeoutController.abort();
          config.signal.addEventListener('abort', externalAbortHandler, { once: true });
        }
      }
      const axiosConfig = { headers, params, signal: timeoutController.signal };

      try {
        const { data } = await axios.get(reportsApi + `stock/historical-value`, axiosConfig);
        return Object.assign({ httpStatus: 200, scope }, data || {});
      } catch (err) {
        const httpStatus = err && err.response ? err.response.status : 0;
        const backendMsg = (err && err.response && err.response.data)
          ? (err.response.data.message || err.response.data)
          : (err && err.message);
        const isAbort = err && (err.code === 'ERR_CANCELED' || err.name === 'CanceledError' || err.name === 'AbortError');

        // 4xx errors (invalid date, no stores in group) are user-correctable —
        // let the caller surface them inline. Keep the generic alert for
        // 5xx / network errors and unknowns.
        if (!isAbort && (httpStatus >= 500 || httpStatus === 0)) {
          errorHandler.tomcatError(err);
        }

        return {
          totalValue: 0,
          httpStatus,
          error: isAbort
            ? (timedOut
                ? `Request timed out after ${Math.round(timeoutMs / 1000)} s — explicit-time queries can take over a minute on large groups.`
                : 'Request cancelled.')
            : (backendMsg || 'Failed to load historical stock value.'),
          aborted: !!isAbort,
          timedOut,
        };
      } finally {
        clearTimeout(timeoutId);
        if (externalAbortHandler && config.signal) {
          try { config.signal.removeEventListener('abort', externalAbortHandler); } catch (_) {}
        }
      }
    },

    /**
     * Download the itemised Excel breakdown behind the period-cost stock
     * value shown in the "Stock Value at Date" widget.
     *
     * Calls `GET {docsApi}/stocks/export/excel/historicalValue?asOfDate=...&store?...`
     * Returns the binary .xlsx as a Blob (responseType: 'blob'). The component
     * is expected to hand the full axios response to `window.openFile(response,
     * fileName)` which handles Android-native vs web download + xlsx MIME
     * detection (see GlobalVariables.js).
     *
     * Scope rules (same single-signal contract as getHistoricalStockValue):
     *  - store: 'sparkrise_spark_rise'  -> ?store=sparkrise_spark_rise, no db header
     *  - store: null  (or omitted when key absent)  -> omit both signals,
     *                                                true group aggregate
     *
     * 4xx bodies are JSON (Spring default). The action reads the error blob
     * as text and rejects with `err.message` so the component can show the
     * real reason in a Swal instead of a generic error.
     *
     * Performance probe (2026-09-22, tenant 1000000000):
     *   group aggregate: ~19 s, ~772 KB
     *   ?store=sparkrise_spark_rise: ~0.2 s, ~5.4 KB
     *   DB header (sparkrise): ~0.2 s, ~5.4 KB (identical to ?store=)
     *   explicit time 18:30:00 + store: ~0.4 s, ~5.4 KB
     * A 60 s client-side timeout is generous for all observed paths.
     *
     * @param {Object} context Vuex context (unused; reads localStorage)
     * @param {Object} payload - { asOfDate: string, asOfDateTime?: string,
     *                            store?: string|null }
     * @returns {Promise<Object>} axios response with .data = Blob
     */
    printHistoricalValueExcel: async (context, payload) => {
      const config = (payload == null) ? {} : (payload || {});

      let stores;
      try {
        stores = JSON.parse(localStorage.getItem('stores'));
      } catch (_) {
        stores = null;
      }
      if (!stores || stores.length === 0) {
        throw new Error('No store selected.');
      }

      const group = stores[0].Group;

      // Single-scope rule: ?store= XOR no signal. Never a db header.
      const params = { asOfDate: config.asOfDateTime || config.asOfDate };
      if (typeof config.store === 'string' && config.store.length > 0) {
        params.store = config.store;
      }

      const headers = { group: window.btoa(String(group)) };

      // 60 s client timeout. Worst observed: 19 s for the group aggregate
      // (12-store tenant); everything else is sub-second.
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000);

      try {
        const response = await axios.get(
          docsApi + 'stocks/export/excel/historicalValue',
          { headers, params, responseType: 'blob', signal: controller.signal }
        );
        return response;
      } catch (err) {
        const isAbort = err && (err.code === 'ERR_CANCELED' || err.name === 'CanceledError' || err.name === 'AbortError');
        // 4xx bodies are JSON blobs. Try to extract the human message.
        if (!isAbort && err && err.response && err.response.data) {
          try {
            const text = await (typeof err.response.data.text === 'function'
              ? err.response.data.text()
              : Promise.resolve(String(err.response.data)));
            try {
              const parsed = JSON.parse(text);
              const status = err.response.status;
              const detail = parsed.message || parsed.error || parsed.path || '';
              const errMsg = new Error(`HTTP ${status}: ${detail || 'Export failed.'}`);
              errMsg.status = status;
              throw errMsg;
            } catch (parseErr) {
              // Body wasn't JSON; fall through with the raw text.
              const errMsg = new Error(`HTTP ${err.response.status}: ${text || 'Export failed.'}`);
              errMsg.status = err.response.status;
              throw errMsg;
            }
          } catch (innerErr) {
            if (innerErr && innerErr.status) throw innerErr;
            throw err;
          }
        }
        if (isAbort) {
          const errMsg = new Error('Export timed out after 60 s.');
          errMsg.timedOut = true;
          throw errMsg;
        }
        throw err;
      } finally {
        clearTimeout(timeoutId);
      }
    },

    getCurrentStockValue: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { totalValue: 0 };

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };

      return axios.get(reportsApi+`stock-dashboard/overview/current-value`, { headers })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return { totalValue: 0 };
        });
    },

    getStockValueByDepartment: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return [];

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/value/by-department`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return [];
        });
    },

    getStoreStockHealth: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return [];

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/health`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return [];
        });
    },

    getDepartmentPerformance: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return [];

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/department-performance`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return [];
        });
    },

    getStockAlerts: async (context) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return {};

      let group = stores[0].Group;
      let headers = { group: window.btoa(group) };
      let params = context.getters.getTimeFrame;

      return axios.get(reportsApi+`stock-dashboard/alerts`, { headers, params })
        .then(({data}) => data)
        .catch(err => {
          errorHandler.tomcatError(err);
          return {
            itemsBelowMinAlert: { storesCount: 0, thresholdPercent: 0 },
            emptyCategories: 0,
            nonMovingStock: 0,
            stockAdjustments: { totalAdjustmentValue: 0 }
          };
        });
    },

    fetchTaxLabels: async (context) => {
      try {
        const { data } = await axios.get("https://lytningtomcat.chrilantech.com/Lyt-SoftBackOfficeApi/zra_category/wholesale_demo/getAll");
        context.commit("setTaxLabels", data);
        return data;
      } catch (err) {
        console.error("Error fetching tax labels:", err);
        errorHandler.tomcatError(err);
        return [];
      }
    },

    fetchCategories: async (context) => {
      try {
        let store = JSON.parse(localStorage.getItem(`selected_store`));
        if (!store || !store.StoreDB) {
          console.error("No store selected or store has no DB");
          return [];
        }

        const storeDB = store.StoreDB;
        const { data } = await axios.get(`https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/category/${storeDB}/getAll`);
        context.commit("setCategories", data);
        return data;
      } catch (err) {
        console.error("Error fetching categories:", err);
        errorHandler.tomcatError(err);
        return [];
      }
    },

    getStockItemStockTakes: async (context, plu) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      let payload = {
        plu,
        ...context.getters.getTimeFrame,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `stock-history/item-stocktake` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },

    getStockItemGRVs: async (context, plu) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      let payload = {
        plu,
        ...context.getters.getTimeFrame,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `stock-history/item-grv` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },

    /**
     * Fetch stock transfer history (received transfers) for the franchise.
     * Calls GET /api/v2/stock/franchise/getHistory
     * @param {Object} context Vuex context
     * @param {Object} params Query parameters (optional)
     * @returns {Promise<Array>} Array of transfer records with totals
     */
    getStockTransferHistory: async (context, params = {}) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { records: [], totals: {} };

      let store = JSON.parse(localStorage.getItem(`selected_store`));
      let storeDB = store && store.StoreDB;

      let group = stores[0].Group;
      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null && storeDB !== undefined ? window.btoa(storeDB) : null,
      };
      let payload = {
        ...context.getters.getTimeFrame,
        ...params,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `stock/franchise/getHistory` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => {
          errorHandler.tomcatError(err);
          return { records: [], totals: {} };
        });
    },

    /**
     * Fetch stock transfer sent records for the franchise.
     * Calls GET /api/v2/stock/franchise/getSentTransfers
     * @param {Object} context Vuex context
     * @param {Object} params Query parameters (optional)
     * @returns {Promise<Array>} Array of transfer records with totals
     */
    getStockTransferSent: async (context, params = {}) => {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return { records: [], totals: {} };

      let store = JSON.parse(localStorage.getItem(`selected_store`));
      let storeDB = store && store.StoreDB;

      let group = stores[0].Group;
      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null && storeDB !== undefined ? window.btoa(storeDB) : null,
      };
      let payload = {
        ...context.getters.getTimeFrame,
        ...params,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `stock/franchise/getSentTransfers` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => {
          errorHandler.tomcatError(err);
          return { records: [], totals: {} };
        });
    }
  },
};

